"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useEffect, useState } from "react";
import { createBoxType } from "../../firebase/boxTypes";
import DialogSuccess from "./DialogSuccess";
import { useAtom } from "jotai";
import { showCreateBoxTypeModalAtom } from "../../store";

export default function DialogCreateBoxType({
    open,
    onClose
}) {
    const [label, setLabel] = useState('')
    const [value, setValue] = useState('')
    const [activeSubmit, setActiveSubmit] = useState(false)
    const [showSuccessDialog, setShowSuccessDialog] = useState(false)
    const [showCreateBoxTypeModal, setShowCreateBoxTypeModal] = useAtom(showCreateBoxTypeModalAtom)

    useEffect(() => {
        setActiveSubmit(label !== '' && value !== '')
    }, [label, value])

    useEffect(() => {
        setLabel('')
        setValue('')
    }, [showCreateBoxTypeModal])

    const handleSubmit = async () => {
        await createBoxType(label, value)
        setShowCreateBoxTypeModal(false)
        setShowSuccessDialog(true)
    }

    return (
        <>
            <DialogSuccess
                message="Box type is successfully added"
                open={showSuccessDialog}
                onClose={() => setShowSuccessDialog(false)}
                buttonText="Back to Dashboard"
                title="Success"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
            />

            <Dialog open={open} onClose={onClose} className="relative z-[10000]">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden w-[550px] bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in  rounded-[15px]"
                        >
                            <div className="w-full flex flex-col relative p-6 min-h-[400px]">
                                <div className="flex justify-between">
                                    <div className="flex">
                                        <span className="text-primary text-[28px]">Create Box Type</span>
                                    </div>

                                    <button
                                        onClick={onClose}
                                        className="top-2 right-2 cursor-pointer z-[1]"
                                    >
                                        <img
                                            src="/assets/icons/icon-close.svg"
                                            alt="Close"
                                            className="invert cursor-pointer"
                                        />
                                    </button>
                                </div>

                                <div className="mt-8">
                                    <div className="text-sm text-primary mb-2">
                                        Label
                                    </div>
                                    <input
                                        className="w-full rounded-[10px] pl-3 py-3 bg-[#272727] text-white"
                                        placeholder="Enter box type label"
                                        value={label}
                                        onChange={(e) => setLabel(e.target.value)}
                                    />
                                </div>

                                <div className="mt-6">
                                    <div className="text-sm text-primary mb-2">
                                        Value
                                    </div>
                                    <input
                                        className="w-full rounded-[10px] pl-3 py-3 bg-[#272727] text-white"
                                        placeholder="Enter box type value"
                                        value={value}
                                        onChange={(e) => setValue(e.target.value)}
                                    />
                                </div>

                                <div className="flex mt-auto text-[#959595] text-sm justify-end">
                                    <button className="w-[143px] h-[42px]" onClick={onClose}>
                                        Cancel
                                    </button>

                                    <button
                                        className={`w-[143px] h-[42px] rounded-[10px] ${activeSubmit ? 'bg-primary text-white' : 'bg-[#E5E5E5]'}`}
                                        onClick={handleSubmit}
                                        disabled={!activeSubmit}
                                    >
                                        Create
                                    </button>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
} 